import {ProductModel} from "../../Models/ProductModel";
import {pdv144Products} from "./pdv144productsMock";

const productMock = new Map<string, ProductModel[]>()

productMock.set("144", pdv144Products)
productMock.set("145", [])

export {productMock}

